import { UpdateItemRequestTrackingDetailsState } from './updateItemRequestTrackingDetails.types'

const initialState: UpdateItemRequestTrackingDetailsState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
